var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"todo",staticClass:"completo"},[_c('canvas',{ref:_vm.myCanvas,on:{"mousemove":_vm.updateInfoDivPosition,"mouseleave":_vm.hideInfoDiv}}),_c('canvas',{ref:"myCanvasLabels",staticClass:"canvas-labels"}),_c('div',{ref:"myCanvasInfo",staticClass:"info-div"},[_vm._v(" Información ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }